import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api/api';
import ClientLayout from '../../components/AdminLayuot';
// 🆕 IMPORTS PARA PDF
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const THEME = {
    primary: '#1F2937', secondary: '#3B82F6', success: '#10B981',
    warning: '#F59E0B', danger: '#EF4444', bg: '#F3F4F6',
    white: '#FFFFFF', border: '#E5E7EB'
};

const STATUS_OPTIONS = [
    { value: 'SOLICITADO', label: '⏳ Nuevo / Solicitado', color: '#F59E0B' },
    { value: 'CONFIRMADO', label: '✅ Confirmado', color: '#3B82F6' },
    { value: 'EN_RUTA', label: '🚚 En Ruta', color: '#8B5CF6' },
    { value: 'ENTREGADO', label: '🏁 Entregado', color: '#10B981' },
    { value: 'CANCELADO', label: '❌ Cancelado', color: '#EF4444' }
];

const PAYMENT_OPTIONS = [
    { value: 'false', label: '⏳ Pendiente de Pago', color: '#EF4444', bg: '#FEE2E2' },
    { value: 'true', label: '✅ Pagado', color: '#10B981', bg: '#D1FAE5' }
];

const MAP_TIPO_PRECIO = {
    'CAFE_AMERICANO': 'precio_cafe_americano',
    'ESPECIALIDAD_CHIAPAS': 'precio_especialidad_chiapas',
    'ESPECIALIDAD_GUERRERO': 'precio_especialidad_guerrero',
    'DESCAFEINADO': 'precio_descafeinado',
    'CAFE_DE_OLLA': 'precio_cafe_olla',
    'CAFE_EJECUTIVO': 'precio_cafe_ejecutivo'
};

const PRODUCT_TYPES = [
    { value: 'CAFE_AMERICANO', label: 'Café Americano' },
    { value: 'ESPECIALIDAD_CHIAPAS', label: 'Especialidad Chiapas' },
    { value: 'ESPECIALIDAD_GUERRERO', label: 'Especialidad Guerrero' },
    { value: 'DESCAFEINADO', label: 'Descafeinado' },
    { value: 'CAFE_DE_OLLA', label: 'Café de Olla' },
    { value: 'CAFE_EJECUTIVO', label: 'Mezcla Ejecutiva' }
];

function AdminDetallePedido() {
    const { id } = useParams();
    const navigate = useNavigate();
    
    const [pedido, setPedido] = useState(null);
    const [perfilCliente, setPerfilCliente] = useState(null);
    const [sucursalesCliente, setSucursalesCliente] = useState([]);
    const [loading, setLoading] = useState(true);
    const [processing, setProcessing] = useState(false);
    
    const [fechaEntrega, setFechaEntrega] = useState('');
    const [editKilos, setEditKilos] = useState({ grano: 0, molido: 0 });
    const [editAvanzado, setEditAvanzado] = useState({ tipoProducto: '', sucursalId: '', notas: '' });

    useEffect(() => {
        fetchData();
    }, [id]);

    const fetchData = async () => {
        const token = localStorage.getItem('token');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            const { data: ped } = await api.get(`/pedidos/${id}`, config);
            setPedido(ped);
            const ownerId = ped.usuario?.parentId || ped.usuarioId;
            if (ownerId) {
                const [perfRes, sucRes] = await Promise.allSettled([
                    api.get(`/profile/admin/${ownerId}`, config),
                    api.get(`/sucursales/usuario/${ownerId}`, config)
                ]);
                if (perfRes.status === 'fulfilled') setPerfilCliente(perfRes.value.data);
                if (sucRes.status === 'fulfilled') setSucursalesCliente(sucRes.value.data || []);
            }
            setEditKilos({ grano: ped.cantidadGrano, molido: ped.cantidadMolido });
            setEditAvanzado({ tipoProducto: ped.tipoProducto, sucursalId: ped.sucursalId, notas: ped.notas || '' });
            if (ped.fechaEntrega) setFechaEntrega(new Date(ped.fechaEntrega).toISOString().split('T')[0]);
            setLoading(false);
        } catch (error) { navigate('/admin/pedidos'); }
    };

    const obtenerPrecioKilo = (tipoProducto) => {
        if (!perfilCliente) return 0;
        const llavePerfil = MAP_TIPO_PRECIO[tipoProducto];
        return Number(perfilCliente[llavePerfil]) || 0;
    };

    const calcularMonto = (grano, molido, tipo) => {
        const precio = obtenerPrecioKilo(tipo);
        return (Number(grano) + Number(molido)) * precio;
    };

    const updatePedido = async (payload) => {
        setProcessing(true);
        const token = localStorage.getItem('token');
        try {
            const { data } = await api.patch(`/pedidos/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setPedido(data); 
            alert("✅ Pedido actualizado");
        } catch (error) { alert("Error al actualizar"); }
        finally { setProcessing(false); }
    };

    const handleSaveKilos = () => {
        const nuevoMonto = calcularMonto(editKilos.grano, editKilos.molido, pedido.tipoProducto);
        if (nuevoMonto === 0) return alert("⚠️ El monto sigue siendo $0. Verifica el precio en el perfil.");
        if (!window.confirm(`¿Actualizar? Nuevo total: $${nuevoMonto.toLocaleString()}`)) return;
        updatePedido({ cantidadGrano: Number(editKilos.grano), cantidadMolido: Number(editKilos.molido), montoTotal: nuevoMonto });
    };

    const handleSaveAvanzado = () => {
        const nuevoMonto = calcularMonto(pedido.cantidadGrano, pedido.cantidadMolido, editAvanzado.tipoProducto);
        if (!window.confirm("¿Aplicar cambios? El precio se recalculará.")) return;
        updatePedido({ ...editAvanzado, montoTotal: nuevoMonto });
    };

    // 🆕 FUNCIÓN PARA GENERAR EL PDF
    const generarPDF = () => {
        const doc = new jsPDF();
        const precio = obtenerPrecioKilo(pedido.tipoProducto);
        const nombreProducto = PRODUCT_TYPES.find(p => p.value === pedido.tipoProducto)?.label || "Café";

        doc.setFontSize(20);
        doc.setTextColor(31, 41, 55);
        doc.text("XAVANA CAFÉ - NOTA DE REMISIÓN", 14, 22);

        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(`Folio: ${pedido.folioRecibo || pedido.id.slice(0,8).toUpperCase()}`, 14, 30);
        doc.text(`Fecha Entrega: ${fechaEntrega}`, 14, 35);

        doc.setFontSize(12);
        doc.setTextColor(0);
        doc.text("DATOS DE ENTREGA", 14, 50);
        doc.line(14, 52, 60, 52);
        doc.setFontSize(10);
        doc.text(`Cliente: ${perfilCliente?.razonSocial || pedido.usuario?.username}`, 14, 60);
        doc.text(`Sucursal: ${pedido.sucursal?.nombre || 'N/A'}`, 14, 65);
        doc.text(`Dirección: ${pedido.sucursal?.direccion || 'N/A'}`, 14, 70);

        autoTable(doc, {
            startY: 80,
            head: [['Producto', 'Presentación', 'Cantidad', 'Precio Unit.', 'Subtotal']],
            body: [
                [nombreProducto, 'Grano', `${pedido.cantidadGrano} Kg`, `$${precio.toFixed(2)}`, `$${(pedido.cantidadGrano * precio).toFixed(2)}`],
                [nombreProducto, 'Molido', `${pedido.cantidadMolido} Kg`, `$${precio.toFixed(2)}`, `$${(pedido.cantidadMolido * precio).toFixed(2)}`],
            ],
            theme: 'striped',
            headStyles: { fillColor: [31, 41, 55] }
        });

        const finalY = doc.lastAutoTable.finalY + 10;
        doc.setFontSize(14);
        doc.text(`TOTAL: $${Number(pedido.montoTotal).toLocaleString('es-MX', {minimumFractionDigits: 2})}`, 140, finalY + 10);

        doc.setFontSize(9);
        doc.text("__________________________", 35, finalY + 45);
        doc.text("Firma de Recibido", 45, finalY + 50);
        doc.text("__________________________", 125, finalY + 45);
        doc.text("Nombre", 135, finalY + 50);

        // 🆕 Nombre dinámico: Sucursal + Fecha
        const nombreSucursal = (pedido.sucursal?.nombre || 'General').replace(/\s+/g, '_');
        const fechaLimpia = fechaEntrega || new Date().toISOString().split('T')[0];

        doc.save(`Remision_Xavana_${nombreSucursal}_${fechaLimpia}.pdf`);
    };

    if (loading) return <div style={{textAlign:'center', padding:50}}>Cargando...</div>;

    const precioPactado = obtenerPrecioKilo(pedido.tipoProducto);
    const montoCalculadoLive = calcularMonto(editKilos.grano, editKilos.molido, pedido.tipoProducto);
    const currentStatus = STATUS_OPTIONS.find(s => s.value === pedido.estado) || STATUS_OPTIONS[0];
    const currentPayment = PAYMENT_OPTIONS.find(p => p.value === String(pedido.pagado));

    return (
        <ClientLayout title={`Administrar Pedido #${id.slice(-6).toUpperCase()}`}>
            <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
                
                <div style={{ background: THEME.primary, color: 'white', padding: 20, borderRadius: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                        <button onClick={() => navigate('/admin/pedidos')} style={{ background: 'transparent', border: 'none', color: '#9CA3AF', cursor: 'pointer' }}>←</button>
                        <div style={{ fontSize: 22, fontWeight: 'bold' }}>{pedido.tipoProducto.replace(/_/g, ' ')}</div>
                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <button onClick={generarPDF} style={{ background: THEME.secondary, color: 'white', border: 'none', padding: '10px 15px', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer' }}>📄 PDF</button>
                        <select 
                            value={pedido.estado} 
                            onChange={(e) => updatePedido({ estado: e.target.value })}
                            style={{ padding: '10px', borderRadius: 8, background: currentStatus.color, color: 'white', fontWeight: 'bold', border: 'none' }}
                        >
                            {STATUS_OPTIONS.map(opt => <option key={opt.value} value={opt.value} style={{color: 'black'}}>{opt.label}</option>)}
                        </select>
                    </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20 }}>
                    {/* TARJETAS DE DATOS IGUALES AL CÓDIGO ANTERIOR */}
                    <div style={styles.card}>
                        <h3 style={styles.sectionTitle}>👤 Cliente</h3>
                        <p style={styles.label}>Empresa</p>
                        <p style={styles.value}>{perfilCliente?.razonSocial || pedido.usuario?.username}</p>
                        <p style={styles.label}>Sucursal</p>
                        <p style={styles.value}>{pedido.sucursal?.nombre}</p>
                        <p style={styles.label}>Dirección</p>
                        <p style={{...styles.value, fontSize: 13, background: THEME.bg, padding: 8, borderRadius: 6}}>{pedido.sucursal?.direccion}</p>
                    </div>

                    <div style={styles.card}>
                        <h3 style={styles.sectionTitle}>☕ Cantidades y Costo</h3>
                        <div style={styles.precioInfoBox}>
                            <span style={styles.miniLabel}>Precio Pactado por Kg:</span>
                            <div style={styles.precioValor}>${precioPactado.toFixed(2)}</div>
                        </div>
                        <div style={{display: 'flex', gap: 10, marginBottom: 15}}>
                            <div style={{flex: 1}}>
                                <label style={styles.label}>Grano (Kg)</label>
                                <input type="number" value={editKilos.grano} onChange={(e) => setEditKilos({...editKilos, grano: e.target.value})} style={styles.input} />
                            </div>
                            <div style={{flex: 1}}>
                                <label style={styles.label}>Molido (Kg)</label>
                                <input type="number" value={editKilos.molido} onChange={(e) => setEditKilos({...editKilos, molido: e.target.value})} style={styles.input} />
                            </div>
                        </div>
                        <button onClick={handleSaveKilos} style={styles.btnSuccess}>💾 Guardar Kilos</button>
                    </div>

                    <div style={styles.card}>
                        <h3 style={styles.sectionTitle}>💰 Finanzas</h3>
                        <div style={styles.label}>Monto Total</div>
                        <div style={{fontSize: 32, fontWeight: 'bold', color: montoCalculadoLive > 0 ? THEME.secondary : THEME.danger, marginBottom: 15}}>
                            ${montoCalculadoLive.toLocaleString()}
                        </div>
                        <select value={String(pedido.pagado)} onChange={(e) => updatePedido({ pagado: e.target.value === 'true' })} style={{ width: '100%', padding: '10px', borderRadius: 8, background: currentPayment.bg, color: currentPayment.color, fontWeight: 'bold', border: `1px solid ${currentPayment.color}`, marginBottom: 15 }}>
                            {PAYMENT_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                        </select>
                        <input type="date" value={fechaEntrega} onChange={(e) => { setFechaEntrega(e.target.value); updatePedido({ fechaEntrega: e.target.value }); }} style={styles.input} />
                    </div>
                </div>

                <div style={{...styles.card, borderTop: `4px solid ${THEME.warning}`}}>
                    <h3 style={styles.sectionTitle}>⚙️ Configuración Avanzada</h3>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20, alignItems: 'end'}}>
                        <div>
                            <label style={styles.label}>Tipo de Café</label>
                            <select style={styles.input} value={editAvanzado.tipoProducto} onChange={e => setEditAvanzado({...editAvanzado, tipoProducto: e.target.value})}>
                                {PRODUCT_TYPES.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                            </select>
                        </div>
                        <div>
                            <label style={styles.label}>Sucursal Destino</label>
                            <select style={styles.input} value={editAvanzado.sucursalId} onChange={e => setEditAvanzado({...editAvanzado, sucursalId: e.target.value})}>
                                {sucursalesCliente.map(s => <option key={s.id} value={s.id}>{s.nombre}</option>)}
                            </select>
                        </div>
                        <div><label style={styles.label}>Notas</label><input style={styles.input} value={editAvanzado.notas} onChange={e => setEditAvanzado({...editAvanzado, notas: e.target.value})} /></div>
                        <button onClick={handleSaveAvanzado} style={{...styles.btnSuccess, background: THEME.warning, marginTop: 0}}>Aplicar Cambios</button>
                    </div>
                </div>
            </div>
        </ClientLayout>
    );
}

const styles = {
    card: { background: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' },
    sectionTitle: { fontSize: '14px', fontWeight: 'bold', textTransform: 'uppercase', color: '#6B7280', borderBottom: `1px solid ${THEME.border}`, paddingBottom: '10px', marginBottom: '20px' },
    precioInfoBox: { background: '#F9FAFB', padding: '12px', borderRadius: '8px', marginBottom: '15px', textAlign: 'center', border: '1px solid #E5E7EB' },
    miniLabel: { fontSize: '10px', color: '#6B7280', textTransform: 'uppercase', fontWeight: 'bold', display: 'block' },
    precioValor: { fontSize: '22px', fontWeight: '800', color: '#111827' },
    label: { fontSize: '11px', fontWeight: 'bold', color: '#9CA3AF', textTransform: 'uppercase', marginBottom: '5px', display: 'block' },
    value: { fontSize: '15px', fontWeight: '600', color: THEME.primary, marginBottom: '15px' },
    input: { width: '100%', padding: '10px', borderRadius: '8px', border: `1px solid ${THEME.border}`, boxSizing: 'border-box' },
    btnSuccess: { width: '100%', padding: '12px', background: THEME.success, color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }
};

export default AdminDetallePedido;